import request from '../request';
import {
  initiate,
  initiateState
} from './initiate';
import {travelerInfoState, travelerInformation} from "./travelerInfo";
import session from '../../services/cda/session';
import { isObjectEmpty } from '../../utils/js/object';

/**
 * @namespace "actions.carAndDriver"
 */

/**
 * @desc Makes cda session request and then hydrates redux models as necessary
 * @param {Object} [data]
 * @param {Object} [requestOpts]
 * @returns {Function}
 * @memberof actions.carAndDriver
 * @example
 * dispatch(actions.carAndDriver.getCdaSession());
 */
export function getCdaSession(data = {}, requestOpts = {}) {
  return dispatch => dispatch(request({data, service:session.current, opts: requestOpts}))
    .then(resp => {
      if (!resp.messages || resp.messages.length === 0) dispatch(hydrateCdaState(resp));
      return resp;
    });
}

/**
 * @desc If we have an updated CDA session -- i.e. from session call, modify, deep link, etc. -- use this
 * @param {Object} sessionData
 * @returns {Function}
 * @memberof actions.carAndDriver
 * @example
 * dispatch(actions.hydrateCdaState(sessionData));
 */
export function hydrateCdaState(sessionData) {
  return dispatch => {
    if (sessionData.deem.booking) {
      if (sessionData.deem.booking.pickup) dispatch(initiateState.set(null, sessionData.deem.booking));
      if (sessionData.deem.booking.passenger && !isObjectEmpty(sessionData.deem.booking.passenger)) dispatch(travelerInfoState.set(null, sessionData.deem.booking));
    }
  };
}

export default {
  getCdaSession,
  initiate,
  travelerInformation,
  hydrateCdaState,

  /**
   * @namespace "actions.carAndDriver.initiateState"
   */
  initiateState,

  /**
   * @namespace "actions.carAndDriver.travelerInfoState"
   */
  travelerInfoState
};
